export default "__VITE_ASSET__sbAjkXB1__ 120w, __VITE_ASSET__DRMcoiHK__ 240w, __VITE_ASSET__DrFm_mG4__ 480w, __VITE_ASSET__CIhGcMGE__ 512w";